export const ERROR_MESSAGES = {
    MAX_OFFERS_REACHED: "Нельзя добавить больше 10 объявлений в сравнение."
};